import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../sidebar';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';

const MainLayout: React.FC = () => {
  const [isMobile, setIsMobile] = useState(false);
  const { isCollapsed } = useSelector((state: RootState) => state.sidebar);
  
  // Calculate sidebar width based on collapse state
  const sidebarWidth = isCollapsed ? '80px' : '208px';

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    // Set initial values
    handleResize();

    // Add event listener
    window.addEventListener('resize', handleResize);
    
    // Clean up
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="flex min-h-screen bg-gray-50 relative">
      {/* Fixed sidebar */}
      <div 
        className="fixed top-0 left-0 h-full z-10"
        style={{ width: isMobile ? '0' : sidebarWidth }}
      >
        <Sidebar />
      </div>
      
      {/* Main content area */}
      <main 
        className="flex-1 overflow-auto transition-all duration-300"
        style={{ 
          marginLeft: isMobile ? '0' : sidebarWidth,
          width: isMobile ? '100%' : `calc(100% - ${sidebarWidth})`,
          paddingTop: isMobile ? "80px" : 0,
          height: '100vh' // Makes the main content take full height
        }}
      >
        <div className="h-full overflow-auto">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default MainLayout;